export default __webpack_public_path__ + "static/media/construction.a4d73e19.svg";